import { ContextTypes } from "api/model/dashboard/DashboardTab";
import { DweenTimeUnitEnum } from "utils/time-utils";

export const defaultYearsSelectionConfig = {
  alignStartTo: DweenTimeUnitEnum.YEARS,
  lag: 0,
  lagUnit: DweenTimeUnitEnum.YEARS,
  lead: 1,
  leadUnit: DweenTimeUnitEnum.YEARS,
  timeOffset: 0,
  timeOffsetUnit: DweenTimeUnitEnum.YEARS,
};

export const defaultRangeDateConfig = {
  alignStartTo: DweenTimeUnitEnum.HOURS,
  lag: 0,
  lagUnit: DweenTimeUnitEnum.HOURS,
  lead: 0,
  leadUnit: DweenTimeUnitEnum.HOURS,
  timeOffset: 0,
  timeOffsetUnit: DweenTimeUnitEnum.HOURS,
};

export const defaultSingleDateSelectionConfig = {
  alignStartTo: DweenTimeUnitEnum.HOURS,
  timeOffset: 0,
  timeOffsetUnit: DweenTimeUnitEnum.HOURS,
};

export const defaultTabContextConfig = {
  contextType: ContextTypes.NONE,
  showBorders: false,
  referenceTime: undefined,
  config: undefined,
};
